import { BaseModel, Guid, RecursivePartial } from '@models/base';

export class ProjectTemplate extends BaseModel {
    id?: Guid;
    name?: string;
    description?: string;
    text?: string;                              // description, plain text or html
    icon?: string;
    color?: string;

    constructor(json?: RecursivePartial<ProjectTemplate>) {
        super(json);
        this.parseProjectTemplate(json || {});
    }

    parse(json: RecursivePartial<ProjectTemplate>): ProjectTemplate {
        super.parse(json);
        this.parseProjectTemplate(json);
        return this;
    }

    private parseProjectTemplate(json: RecursivePartial<ProjectTemplate>): void {
        ProjectTemplate.assignFields(this, json, ['id', 'name', 'description', 'text', 'icon', 'color']);
    }

}
